import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CostCenter } from '@work4all/models/lib/Classes/CostCenter.entity';

import { IFilterPickerConfig } from '../../../../components/entity-picker/components/list-entity-picker';
import { CostCenterPicker } from '../../../../components/entity-picker/costCenter-Picker/CostCenterPicker';
import { FilterCard } from '../filter-card/FilterCard';

export type ICostCenterFilterCardProps = {
  title: string;
  value: CostCenter[] | null;
  onChange: (value: CostCenter[]) => void;
  expanded: boolean;
  onExpandedChange: (val: boolean) => void;
  filterConfig?: IFilterPickerConfig;
};

export function CostCenterFilterCard(props: ICostCenterFilterCardProps) {
  const { title, value, onChange, expanded, onExpandedChange, filterConfig } =
    props;

  const { t } = useTranslation();

  const filterValueText: string = useMemo(() => {
    if (!value || value.length === 0) return null;

    return t('COMMON.CHOSEN', { count: value.length });
  }, [value, t]);

  return (
    <FilterCard
      title={title}
      filterValue={filterValueText}
      filterValueSet={!!filterValueText}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      onValueDelete={() => {
        onChange([]);
      }}
    >
      <CostCenterPicker
        layout="advanced"
        multiple={true}
        value={value}
        onChange={(newValue) => {
          onChange(newValue);
        }}
        filterConfig={filterConfig}
      />
    </FilterCard>
  );
}
